module.exports = __webpack_public_path__ + "static/media/20e.566a4fdf.pdf";